import React, { useState } from 'react';
import { Poll as PollIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { ModalPopup } from '../Elements/Modal';

import { GeneralSurveyModalContent } from './GeneralSurvey/GeneralSurveyModalContent';

import { OPEN } from '../../constants/Surveys';

export const OpenModalButton = ({
  questions = {},
  label,
  modalTitle,
  handleContinue,
  isLastStep,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ModalPopup
      buttonContent={
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 1, mr: 1, color: 'black', borderColor: 'black' }}
        >
          <PollIcon sx={{ mr: 0 }} /> {OPEN}
        </Button>
      }
      modalContent={
        <GeneralSurveyModalContent
          generalSurveyQuestions={questions}
          label={label}
          handleContinue={handleContinue}
          isLastStep={isLastStep}
        />
      }
      title={modalTitle}
      modalButtonId={'open-survey-modal-button'}
      handleOpen={() => setIsOpen(true)}
      handleClose={() => setIsOpen(false)}
      open={isOpen}
    />
  );
};
